export const FETCH_ORGANIZATIONS_STARTED = 'FETCH_ORGANIZATIONS_STARTED' as const;
export const FETCH_ORGANIZATIONS_FULFILLED = 'FETCH_ORGANIZATIONS_FULFILLED' as const;

export const fetchOrganizations = (data?: Record<string, unknown>) => ({
  type: FETCH_ORGANIZATIONS_STARTED,
  payload: data,
});
export const fetchOrganizationsFulfilled = (data: unknown) => ({
  type: FETCH_ORGANIZATIONS_FULFILLED,
  payload: data,
});
